<template lang='pug'>
  blue-layout( :user='user' :account='account' :biz='biz' )
    bf-wrapper#notifications.view.content.with-header.smaller.container
      bf-overlay#rsv-overlay.solid(
        v-if='rsv'
        :user='user',
        :account='account',
        :biz='biz',
        :data='rsv',
        @close='rsv = false'
      )
        template( v-slot:heading )
          h5 {{ $t('Reservation/Appointment Details') }}
        #rsv-dtls.container
          rsv-dtls.overlay(
            v-if='rsv'
            :rsv='rsv'
            :options='{ show: { biz: true, cus: true } }'
          )
        rsv-msgs#rsv-msgs(
          v-if='rsv && account'
          :rsv='rsv'
          :account='account'
          :key='rsv.id'
        )

      notifications-tabs( :account='account' :notifications='notifications' :biz='biz' )

      h4( v-if='!notes.length' ) {{$t("No Messages")}}!
      span(v-else) {{notes.length}} {{ $t("messages")}}
      .container.actionable( 
        v-for='n in notes' 
        :key='n.id'
        :class='{ read: n.read }'
        @click='view( n )' 
      )
        .remove.actionable( @click.stop='remove(n)' )
          remove-icon

        bf-flex.msg.note(
          v-if='n.type == "msg"'
          :class='{ customer: n.sender == "customer", merchant: n.sender == "merchant" }'
        )
          .avatar
            img(:src='n.msg.sent.by.avatar || "/no-image.png"')
          .contents
            .name-date
              span.name {{ n.msg.sent.by.name || n.msg.sent.by.email }}
              span.date {{ n.msg.sent.on.toDate().toLocaleString() }}
            .type(:class='{ notable: n.msg.cancellation }') {{ n.msg.cancellation ? $t('Cancellation Request') : $t('New Message') }}
            .content {{ n.msg.content }}

        bf-flex.rsv.note.container(
          v-if='n.type == "rsv"'
          :class='{ customer: n.rsv.business_id == biz.id, merchant: n.rsv.account_id == account.id }'
        )
          .avatar
            img(
              v-if='n.rsv.business_id == biz.id'
              :src='n.cus.avatar || "/no-image.png"'
            )
            img(
              v-else
              :src='n.biz.logo'
            )
          .contents
            .name-date
              span.name {{ n.rsv.account_id == account.id ? n.biz.name : n.cus.name || n.cus.email }}
              span.date {{ n.created.toDate().toLocaleString() }}
            .type {{ $t('New Reservation') }}
            .start
              label {{ $t('Scheduled On:') }}
              span.datetime {{ n.rsv.datetime.start.toDate().toLocaleString() }}
            .srv
              label {{ $t('For:') }}
              span.name {{ n.rsv.service.title }}

        bf-flex.rsv.note.container(
          v-if='n.type == "cus"'
          :class='{ customer: true, merchant: false }'
        )
          .avatar
            img(:src='n.cus.account.avatar || "/no-image.png"')
          .contents
            .name-date
              span.name {{ n.cus.name || n.cus.email }}
              span.date {{ n.created.toDate().toLocaleString() }}
            .type {{ $t('New Customer') }}
            .start
              label Acquired On:
              span.datetime {{ n.created.toDate().toLocaleString() }}

        bf-flex.rsv.note.container(
          v-if='n.type == "can"'
          :class='{ customer: true, merchant: false }'
        )
          .avatar
            img(
              v-if='n.rsv.account_id == account.id'
              :src='n.biz.logo || "/no-image.png"'
            )
            img(
              v-else
              :src='n.confirmed.by.merchant ? n.biz.logo || "/no-image.png" : n.cus.avatar || "/no-image.png"'
            )
          .contents
            .name-date
              span.name {{ n.confirmed.by.merchant ? n.biz.name : n.cus.name || n.cus.email }}
              span.date {{ n.created.toDate().toLocaleString() }}
            .type.notable {{ $t('Reservation Canceled') }}
            .srv
              label For:
              span.name {{ n.rsv.service.title }}
              span.date {{ n.rsv.datetime.start.toDate().toLocaleString() }}
</template>
<script>
  import { db } from '@/main'
  import { View } from '@/mixins/view'
  import NotificationsTabs from '@/components/tabs/notifications'

  export default {
    name: 'per-notifications.view',

    mixins: [ View ],

    components: {
      NotificationsTabs
    },

    props: [ 'notifications' ],

    data() {
      return {
        rsv: false
      }
    },

    computed: {
      notes() {
        if ( this.biz && this.account ) return this.notifications.filter( n => {
          switch( n.type ) {
            case 'msg' : return n.for == this.account.id
            case 'rsv' : return n.for == this.account.id && n.biz.user_id != this.account.id
            case 'cus' : return n.cus.business_id == this.biz.id
            case 'can' : return n.cus == this.account.id
            default: return false
          }
        })
        else return []
      }
    },

    methods: {
      remove(n) {
        db.collection('notifications').doc(n.id).delete()
      },

      view( n ) {
        db.collection( 'notifications' ).doc( n.id ).update({ read: true }).then( () => console.log('updated', n) )
        this.rsv = n.rsv
      }
    }
  }
</script>

<style scoped lang='stylus'>
  #rsv-overlay
    margin-top 16px
  
  .container
    margin 12px 0
    .remove
      position absolute
      right 2px
      top 2px
      font-size 1.2em
      z-index 1
      opacity .75
    &.read .note
      background rgb( 240 240 240 )

  .note
    padding 8px
    border 1.5px solid rgb( 240 240 240 )
    border-radius 5px
    line-height 1.5
    font-size .92em
    &.customer
      background rgb( 240 255 240 )
    &.merchant
      background rgb( 255 250 240 )

  .container
    align-items center

  .avatar
    margin-right 16px
    img
      width 48px
      height 48px
      object-fit cover
      border-radius 50%

  label
    margin-right 4px

  .name, .datetime
    font-weight bold
    color var(--clr-blue-light)
    margin-right 8px

  .date
    font-size .8em
    color rgb( 144 144 144 )

  .type
    font-weight bold
</style>
